var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirdSuccess1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 195,
    viewBox: "0 0 98 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9031 114.737L30.0148 191.283L46.5534 179.007L63.9119 190.37L58.4994 114.737L38.9031 114.737Z",
    fill: "#009846"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4995 114.572L58.7989 118.728L38.4419 118.728L38.899 114.739L58.4995 114.572Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8449 114.465C41.1598 130.405 39.8596 146.317 37.934 162.155C38.6142 146.215 39.9239 130.304 41.8449 114.465Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6842 113.092C57.7605 129.62 58.2231 146.187 58.0555 162.749C56.9742 146.221 56.5212 129.654 56.6842 113.092Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1373 113.79C49.4307 130.215 49.1084 146.649 48.1577 163.049C47.8593 146.625 48.1908 130.19 49.1373 113.79V113.79Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0071 113.432C53.5936 130.074 53.5651 146.737 52.9073 163.377C52.3159 146.735 52.3536 130.071 53.0071 113.432Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4602 114.13C45.2107 130.567 44.3456 146.994 42.8531 163.366C43.0979 146.929 43.9722 130.502 45.4602 114.13V114.13Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1224 30.3116C18.1224 30.3116 31.1179 0.0646801 48.4874 0.0646973C73.6432 0.0647221 79.5147 33.6058 79.5147 33.6058C79.5147 33.6058 96.1674 43.1118 95.6814 73.675C95.277 99.1004 72.0036 116.351 48.4874 115.955C30.4274 115.65 4.47283 105.625 0.489862 80.3254C-3.49343 55.0255 18.1224 30.3116 18.1224 30.3116Z",
    fill: "#009846"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2264 102.256C54.5527 100.511 55.5998 105.391 56.3983 107.432C57.3066 109.753 58.0456 110.838 59.644 111.076",
    stroke: "#263138",
    strokeWidth: 1.62668,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2754 102.271C64.5363 100.453 63.5817 105.541 62.8539 107.668C62.0256 110.089 61.3521 111.22 59.8947 111.469",
    stroke: "#263138",
    strokeWidth: 1.62668,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4047 102.247C67.9555 100.542 67.16 105.312 66.5533 107.307C65.8633 109.576 65.3019 110.637 64.0874 110.87",
    stroke: "#263138",
    strokeWidth: 1.62668,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4768 102.256C25.8031 100.511 26.8502 105.391 27.6487 107.432C28.5569 109.753 29.2959 110.838 30.8944 111.076",
    stroke: "#263138",
    strokeWidth: 1.62668,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1089 102.372C29.4356 100.628 30.4826 105.507 31.2808 107.548C32.1893 109.869 32.928 110.954 34.5265 111.193",
    stroke: "#263138",
    strokeWidth: 1.62668,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.655 102.247C39.2058 100.542 38.4103 105.312 37.8037 107.307C37.1136 109.576 36.5522 110.637 35.3378 110.87",
    stroke: "#263138",
    strokeWidth: 1.62668,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9594 33.6056C79.9594 33.6056 80.2694 36.2494 79.9595 55.1677C79.7014 70.9214 59.7558 77.2214 44.7649 76.9763C29.5889 76.7282 16.5128 66.1035 16.7742 50.1407C16.9455 39.6839 15.0096 36.9537 17.6688 30.9102C20.963 23.4234 22.1609 22.8246 22.1609 22.8246C23.9578 18.6319 27.1529 14.4258 31.4446 9.64755C34.8448 5.86192 38.4822 1.51379 44.921 0.36397C61.6915 -2.63089 71.5742 13.8403 71.5742 13.8403C71.5742 13.8403 73.0716 15.0382 74.2695 18.6319C76.9647 23.7229 76.1433 22.0789 77.5637 25.8193C78.9852 29.5627 79.9594 33.6056 79.9594 33.6056Z",
    fill: "white",
    fillOpacity: 0.301961
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.965 25.5195C78.1629 29.7122 81.7566 36.0011 71.8739 40.1938C63.1892 42.889 68.4965 37.199 51.127 37.199C32.5596 36.3006 38.474 41.3917 27.4685 38.3969C21.8216 36.8603 22.4606 21.9258 22.4606 21.9258L26.0543 16.0103C26.0543 16.0103 31.325 10.3478 38.474 10.2463L62.0701 10.6322C71.8097 10.7915 75.7671 21.3269 76.965 25.5195Z",
    fill: "white",
    fillOpacity: 0.501961
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.39 31.1771L49.2684 25.8193L41.3275 31.1771L49.2684 42.2904L57.39 31.1771Z",
    fill: "#263138"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7022 23.2031C57.6901 20.2056 62.8586 16.0092 67.6295 23.2031",
    stroke: "black",
    strokeWidth: 2.30539
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3429 23.2031C34.3308 20.2056 39.4993 16.0092 44.2703 23.2031",
    stroke: "black",
    strokeWidth: 2.30539
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1399 30.6108L16.772 114.101C16.772 114.101 -0.332876 90.0585 0.00489154 69.4424C0.434348 43.2287 18.1399 30.6108 18.1399 30.6108V30.6108Z",
    fill: "#009846"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1399 30.6108L16.772 114.101C16.772 114.101 -0.332876 90.0585 0.00489154 69.4424C0.434348 43.2287 18.1399 30.6108 18.1399 30.6108V30.6108Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98094 94.5757C5.69599 93.918 5.41082 93.2483 5.13816 92.566C5.30847 79.1644 5.67765 65.6549 6.23251 52.8879C6.36999 66.3071 6.28522 80.5231 5.98094 94.5757Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83307 102.573C9.58205 102.089 9.33092 101.604 9.06783 101.107C9.18433 84.9693 9.57887 68.4174 10.2513 52.9541C10.434 68.8994 10.2776 85.9853 9.83307 102.573Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6567 109.288C13.4644 108.989 13.2723 108.666 13.0805 108.33C13.098 89.9604 13.511 70.7724 14.2828 53.019C14.4676 71.0957 14.2582 90.6446 13.6567 109.288V109.288Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0612 31.2102L80.429 114.7C80.429 114.7 97.5339 90.6579 97.1962 70.0418C96.7667 43.8281 79.0612 31.2102 79.0612 31.2102V31.2102Z",
    fill: "#009846"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0612 31.2102L80.429 114.7C80.429 114.7 97.5339 90.6579 97.1962 70.0418C96.7667 43.8281 79.0612 31.2102 79.0612 31.2102V31.2102Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2201 95.175C91.5051 94.5173 91.7903 93.8477 92.0629 93.1654C91.8926 79.7638 91.5234 66.2543 90.9686 53.4873C90.8311 66.9065 90.9159 81.1225 91.2201 95.175Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.368 103.173C87.619 102.688 87.8701 102.203 88.1332 101.706C88.0167 85.5684 87.6222 69.0166 86.9497 53.5532C86.767 69.4985 86.9235 86.5844 87.368 103.173Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5445 109.887C83.7367 109.588 83.9289 109.265 84.1206 108.929C84.1032 90.5597 83.6902 71.3718 82.9183 53.6184C82.7335 71.6951 82.9429 91.244 83.5445 109.887V109.887Z",
    fill: "black",
    fillOpacity: 0.101961
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_419_4812)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0822,
    cy: 28.2154,
    rx: 10.1821,
    ry: 2.99474,
    fill: "#FFBFE1",
    fillOpacity: 0.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_419_4812)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.7441,
    cy: 27.6158,
    rx: 10.1821,
    ry: 2.99474,
    fill: "#FFBFE1",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_419_4812",
    x: 54.5947,
    y: 22.9153,
    width: 24.975,
    height: 10.6003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15269,
    result: "effect1_foregroundBlur_419_4812"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_419_4812",
    x: 19.2566,
    y: 22.3157,
    width: 24.975,
    height: 10.6003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.15269,
    result: "effect1_foregroundBlur_419_4812"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdSuccess1);
export default __webpack_public_path__ + "static/media/bird_success1.044405dd4d6728aeee5b3b0eaf8b1846.svg";
export { ForwardRef as ReactComponent };